import { AlertCircle } from 'lucide-react';

interface ErrorStateProps {
  message: string;
  hint?: string;
  onRetry?: () => void;
  isLoading?: boolean;
}

export default function ErrorState({ message, hint, onRetry, isLoading = false }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-100 text-center px-8">
      <div className="w-16 h-16 rounded-full bg-destructive/20 border border-destructive/40 flex items-center justify-center mb-4">
        <AlertCircle className="w-7 h-7 text-destructive" />
      </div>
      <h2 className="text-lg font-medium text-destructive mb-2">Investigation Failed</h2>
      <p className="text-sm text-muted-foreground max-w-md leading-relaxed mb-4">{message}</p>
      {hint ? (
        <p className="text-xs text-muted-foreground max-w-md leading-relaxed mb-4 border-t border-border pt-3">
          {hint}
        </p>
      ) : null}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          disabled={isLoading}
          className="px-4 py-2 text-sm bg-card border border-border rounded-lg text-foreground hover:text-white hover:border-accent transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Retrying…' : 'Try Again'}
        </button>
      )}
    </div>
  );
}
